import React, { useState, useEffect, useMemo } from "react";
import SearchBar from "../components/SearchBar";
import { getCoins } from "../services/api";
import CoinCard from "../components/CoinCard";
import ReactPaginate from "react-paginate";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const paginationStyles = `
  .pagination-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
  }

  .pagination {
    display: flex;
    list-style: none;
    align-items: center;
    margin: 0;
    padding: 0;
  }

  .pagination a {
    padding: 6px 10px;
    text-decoration: none;
    color: #4299e1;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .pagination :not(.next):not(.previous) a:hover {
    border-bottom: 2px solid #4299e1;
    transition: ease-in-out 100ms;
  }

  .pagination .active a {
    border-bottom: 2px solid #4299e1;
    transition: ease-in-out 100ms;
  }

  @media (max-width: 768px) {
    .pagination li {
      margin: 0 3px;
    }

    .pagination a {
      padding: 4px 8px;
    }
  }
`;

const Cryptocurrencies = () => {
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [coins, setCoins] = useState([]);
  const [error, setError] = useState(null);
  const [visibleCoins] = useState(9);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchCoins = useMemo(
    () => async () => {
      try {
        setLoading(true);
        const response = await getCoins(query);
        console.log("getCoins Response:", response.data);
        setCoins(response.data);
        setLoading(false);
      } catch (error) {
        setError(
          "Ops...a limit reached for API usage, please try again later."
        );
        setLoading(false);
      }
    },
    [query]
  );

  useEffect(() => {
    fetchCoins();
  }, [fetchCoins]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const filteredCoins = coins.filter(
    (coin) =>
      coin.name.toLowerCase().includes(query.toLowerCase()) ||
      coin.symbol.toLowerCase().includes(query.toLowerCase())
  );

  const totalPages = Math.ceil(filteredCoins.length / visibleCoins);

  return (
    <div className="container">
      <p className="mx-2 my-12 uppercase font-black text-transparent animate-text bg-gradient-to-r from-blue-500 via-cyan-500 to-violet-500 bg-clip-text text-2xl">
        All Cryptocurrencies
      </p>
      <SearchBar query={query} setQuery={setQuery} />
      {loading ? (
        <div className="text-center text-gray-600">Loading...</div>
      ) : error ? (
        <div className="text-center text-red-500 font-bold mt-32">{error}</div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-center">
            {filteredCoins
              .slice(
                (currentPage - 1) * visibleCoins,
                currentPage * visibleCoins
              )
              .map((coin) => (
                <div key={coin.id} className="max-w-sm mx-auto mt-12">
                  <CoinCard coin={coin} />
                </div>
              ))}
          </div>

          {totalPages > 1 && (
            <div className="pagination-container">
              <style>{paginationStyles}</style>
              <ReactPaginate
                pageCount={totalPages}
                pageRangeDisplayed={5}
                marginPagesDisplayed={2}
                onPageChange={handlePageChange}
                initialPage={currentPage - 1}
                containerClassName="pagination"
                activeClassName="active"
                previousLabel={<FaChevronLeft />}
                nextLabel={<FaChevronRight />}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Cryptocurrencies;
